// JogosDoDia.jsx
import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import "./JogosDoDia.css";
import Spinner from "../components/Spinner";


// Lista de abreviações
const abreviacoes = {
  "Club": "C.",
  "Atlético": "Atl.",
  "Sporting": "S.",
  "Deportivo": "Dep.",
  "Universidad": "U.",
  "Universitario": "Univ.",
  "Internacional": "Inter",
  "Nacional": "Nac.",
  "Manchester": "Man.",
  "Real": "R.",
  "Juventus": "Juv.",
  "Barcelona": "Barça",
  "Corinthians": "Corinth.",
  "Fluminense": "Flu",
  "Botafogo": "Bota",
  "Esporte": "E.",
  "Clube": "C.",
  "Futebol": "F.",
  "Associação": "Assoc."
};

// Função de abreviação
function abreviarNome(nome, limite = 25) {
  if (!nome) return "";

  const palavras = nome.split(" ");
  let abreviado = palavras.map(p => abreviacoes[p] || p).join(" ");

  const houveAbreviacao = palavras.some(p => abreviacoes[p]);

  // fallback: só se não houve abreviação E o nome for longo
  if (!houveAbreviacao && nome.length > limite) {
    abreviado = palavras
      .map(p => {
        // mantém conectores curtos como "de", "da", "y", "e"
        if (p.length <= 2) return p;
        return p[0].toUpperCase() + ".";
      })
      .join(" ");
  }

  // se ainda for longo, corta com "..."
  return abreviado.length > limite ? abreviado.slice(0, limite) + "…" : abreviado;
}




function normalizeArrayPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

export default function JogosDoDia() {
  const [jogos, setJogos] = useState([]);
  const [teamsMap, setTeamsMap] = useState({});
  const [selectedDay, setSelectedDay] = useState("hoje");
  const [mostrarA, setMostrarA] = useState(true);
  const [mostrarB, setMostrarB] = useState(true);
  const [mostrarC, setMostrarC] = useState(true);
  const [ordenarPor, setOrdenarPor] = useState("score");

  // Carregar times
  async function fetchTeams() {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/teams`);
      const payload = await res.json();
      const data = normalizeArrayPayload(payload);
      const map = {};
      data.forEach((t) => {
        if (t && t.bzzoiro_id) {
          map[t.bzzoiro_id] = t.team_name;
        }
      });
      setTeamsMap(map);
    } catch (err) {
      console.error("Erro ao carregar times:", err);
      setTeamsMap({});
    }
  }

  

  // Carregar jogos do dia com parâmetro ?dias
  async function fetchJogos(dias = 5) {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/daily-matches?dias=${dias}`);
      const data = await res.json();
      const ordenados = [...(data || [])].sort(
        (a, b) => new Date(a.event_date) - new Date(b.event_date)
      );
      return ordenados;
    } catch (err) {
      console.error("Erro ao carregar jogos:", err);
      return [];
    }
  }

  // Carregar indicadores
  async function fetchIndicadores() {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/indicators/expectativas`);
      const data = await res.json();
      return data || [];
    } catch (err) {
      console.error("Erro ao carregar indicadores:", err);
      return [];
    }
  }

  // Cache local para evitar buscar repetidamente
let leaguesCache = null;

async function getLeagueName(leagueId) {
  try {
    if (!leaguesCache) {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/leagues`);
      const payload = await res.json();
      leaguesCache = payload && typeof payload === "object" ? payload : {};
    }

    const countries = Object.keys(leaguesCache || {});
    for (const country of countries) {
      const leagueList = Array.isArray(leaguesCache[country]) ? leaguesCache[country] : [];
      const liga = leagueList.find((l) => Number(l.id) === Number(leagueId));
      if (liga) return liga.name;
    }

    return "Liga desconhecida";
  } catch (err) {
    console.error("Erro ao buscar liga:", err);
    return "Erro ao carregar";
  }
}

const [loading, setLoading] = useState(false);

useEffect(() => {
  let ignore = false;

  async function carregarTudo() {
    setLoading(true);

    try {
      const [teamsPayload, indicadoresPayload] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/teams`).then((res) => {
          if (!res.ok) return [];
          return res.json();
        }),
        fetch(`${process.env.REACT_APP_API_URL}/indicators/expectativas`).then((res) => {
          if (!res.ok) return { jogos: [] };
          return res.json();
        })
      ]);

      if (ignore) return;

      const teamsData = normalizeArrayPayload(teamsPayload);
      const map = {};
      teamsData.forEach((t) => {
        if (t && t.bzzoiro_id) {
          map[t.bzzoiro_id] = t.team_name;
        }
      });
      setTeamsMap(map);

      const diaSelecionado = dias.find((d) => d.id === selectedDay);
      const alvo = new Date();
      if (diaSelecionado) {
        alvo.setDate(alvo.getDate() + diaSelecionado.offset);
      }

      const jogosArray = Array.isArray(indicadoresPayload?.jogos) ? indicadoresPayload.jogos : [];
      const jogosFiltrados = jogosArray.filter((jogo) => {
        if (!jogo?.event_date) return false;
        return new Date(jogo.event_date).toDateString() === alvo.toDateString();
      });

      const ordenados = [...jogosFiltrados].sort(
        (a, b) => new Date(a.event_date) - new Date(b.event_date)
      );

      const jogosComLiga = await Promise.all(
        ordenados.map(async (jogo) => {
          const nomeLiga = await getLeagueName(jogo.league_id);
          return { ...jogo, league_name: nomeLiga };
        })
      );

      if (!ignore) {
        setJogos(jogosComLiga);
      }
    } catch (err) {
      console.error("Erro ao carregar jogos:", err);
      if (!ignore) {
        setJogos([]);
      }
    } finally {
      if (!ignore) {
        setLoading(false);
      }
    }
  }

  carregarTudo();
  return () => {
    ignore = true;
  };
}, [selectedDay]);

  // Definição das abas de dias
  const dias = [
    { label: "Hoje", offset: 0, id: "hoje" },
    { label: "Amanhã", offset: 1, id: "amanha" },
    { label: "+2 dias", offset: 2, id: "+2" },
    { label: "+3 dias", offset: 3, id: "+3" },
    { label: "+4 dias", offset: 4, id: "+4" },
  ];







  // Filtrar jogos para o dia específico
  function filtrarPorDia(diaOffset) {
    const hoje = new Date();
    const alvo = new Date(hoje);
    alvo.setDate(hoje.getDate() + diaOffset);
    return jogos.filter(
      (j) => new Date(j.event_date).toDateString() === alvo.toDateString()
    );
  }

  const jogosFiltrados = filtrarPorDia(
    dias.find((d) => d.id === selectedDay)?.offset || 0
  );

  // Ordenação
  const jogosOrdenados =
    ordenarPor === "score"
      ? [...jogosFiltrados].sort((a, b) => b.score - a.score)
      : [...jogosFiltrados].sort(
          (a, b) => new Date(a.event_date) - new Date(b.event_date)
        );

  // Função utilitária para fallback de nomes
  function getTeamName(jogo, isHome = true) {
    const id = isHome ? jogo.home_team_id : jogo.away_team_id;
    const nameFromMap = teamsMap[id];
    const nameFromDb = isHome ? jogo.home_team_name : jogo.away_team_name;
    return nameFromMap || nameFromDb || `Time ${id}`;
  }
  return (
    <AppLayout>
      <div className="jogos-container">
        <h2 className="jogos-header">⚽ Jogos do Dia</h2>

        {/* Abas de dias */}
        <div className="dia-tabs">
          {dias.map((d) => (
            <button
              key={d.id}
              className={`dia-tab ${selectedDay === d.id ? "ativo" : ""}`}
              onClick={() => setSelectedDay(d.id)}
            >
              {d.label}
              <br />
              <span className="dia-data">
                {new Date(new Date().setDate(new Date().getDate() + d.offset)).toLocaleDateString("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                })}
              </span>
            </button>
          ))}
        </div>

        {/* Indicadores selecionáveis */}
        <div className="indicadores">
          <label>
            <input
              type="checkbox"
              checked={mostrarA}
              onChange={() => setMostrarA(!mostrarA)}
            /> Meta Momentum
          </label>
          <label>
            <input
              type="checkbox"
              checked={mostrarB}
              onChange={() => setMostrarB(!mostrarB)}
            /> Poisson Momentum
          </label>
          <label>
            <input
              type="checkbox"
              checked={mostrarC}
              onChange={() => setMostrarC(!mostrarC)}
            /> Média Simples
          </label>

          <select
            value={ordenarPor}
            onChange={(e) => setOrdenarPor(e.target.value)}
            className="ordenar-select"
          >
            <option value="score">SP Score</option>
            <option value="horario">Horário</option>
          </select>
        </div>

     {/* Tabela de jogos ou fallback */}
{loading ? (
  <Spinner />
) : jogosOrdenados.length > 0 ? (
  <table className="jogos-tabela">
    <thead>
      <tr>
        <th>#</th>
        <th>Jogo</th>
        <th>Horário</th>
        {mostrarA && <th>Meta Momentum</th>}
        {mostrarB && <th>Poisson Momentum</th>}
        {mostrarC && <th>Média Simples</th>}
        <th>SP Score</th>
      </tr>
    </thead>
    <tbody>
      {jogosOrdenados.map((jogo, idx) => (
        <tr key={idx}>
          <td>{idx + 1}</td>
          <td className="jogo-coluna">
            <div className="jogo-wrapper">
              <div className="escudos-confronto">
                <img
                  src={`https://sports.bzzoiro.com/img/team/${jogo.home_team_id}/`}
                  alt={getTeamName(jogo, true)}
                  className="escudo"
                  onError={(e) => (e.target.src = "/images/default-shield.png")}
                />
                <span className="confronto">
                  <span className="time-nome">{abreviarNome(getTeamName(jogo, true))}</span>
                  <span className="versus"> x </span>
                  <span className="time-nome">{abreviarNome(getTeamName(jogo, false))}</span>
                </span>
                <img
                  src={`https://sports.bzzoiro.com/img/team/${jogo.away_team_id}/`}
                  alt={getTeamName(jogo, false)}
                  className="escudo"
                  onError={(e) => (e.target.src = "/images/default-shield.png")}
                />
              </div>

              {/* Nome da liga abaixo do confronto */}
              <div className="liga-nome">{jogo.league_name}</div>
            </div>
          </td>

          <td>
            {new Date(jogo.event_date).toLocaleTimeString("pt-BR", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </td>

          {mostrarA && (
            <td>
              <div className="barra-container">
                <div
                  className="barra azul"
                  style={{ width: `${jogo.indicators?.metaDisplay ?? 0}%` }}
                ></div>
              </div>
              <span className="valor-indicador">
                {Number(jogo.indicators?.metaDisplay ?? 0).toFixed(0)}
              </span>
            </td>
          )}

          {mostrarB && (
            <td>
              <div className="barra-container">
                <div
                  className="barra verde"
                  style={{ width: `${jogo.indicators?.poissonDisplay ?? 0}%` }}
                ></div>
              </div>
              <span className="valor-indicador">
                {Number(jogo.indicators?.poissonDisplay ?? 0).toFixed(0)}
              </span>
            </td>
          )}

          {mostrarC && (
            <td>
              <div className="barra-container">
                <div
                  className="barra laranja"
                  style={{ width: `${jogo.indicators?.mediaDisplay ?? 0}%` }}
                ></div>
              </div>
              <span className="valor-indicador">
                {Number(jogo.indicators?.mediaDisplay ?? 0).toFixed(0)}
              </span>
            </td>
          )}

          <td className="score-circulo">
            {Number(jogo.score ?? 0).toFixed(0)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
) : (
  <div className="fallback">
    <img
      src={require("../assets/no-games.png")}
      alt="Sem jogos disponíveis"
      className="fallback-img"
    />
    <p>Sem jogos desta liga para os próximos dias.</p>
  </div>
)}

      </div>
      <Footer />
    </AppLayout>
  );
}
